{
  "nl": {
    "apps": {
      "ai_assistant": {
        "color": "var(--brand-7)",
        "description": "Ontdek handige chatbots voor jou en je leerlingen.",
        "descriptionPupils": "Ontdek handige chatbots voor jou en je leerlingen.",
        "icon": "bi-grid-3x3",
        "longDescriptionHtml": "Met deze tool kunnen leerlingen historische of fictieve personages leren kennen en ermee interacteren. Leerlingen kunnen in rollenspellen, schrijfprojecten, presentaties en andere creatieve activiteiten met deze personages interacteren en ze beter begrijpen.",
        "name": "Assistentencatalogus",
        "useCasesHtml": "<ul> <li>Creatief schrijven: Leerlingen kunnen essays of korte verhalen schrijven waarin ze in dialoog gaan met historische of fictieve personages en hun gedachten en gevoelens delen.</li> <li>Voordrachten en presentaties: Leerlingen kunnen onderzoek doen naar historische of fictieve personages en presentaties geven om hun kennis en begrip te tonen en hun persoonlijkheden te bespreken.</li> <li>Quiz- en Trivia-spellen: Leerlingen kunnen quiz- of triviaspellen spelen waarin ze vragen beantwoorden over historische of fictieve personages om hun kennis te testen en te verdiepen.</li> </ul>"
      },
      "ai_audio": {
        "description": "Laat audiosporen uit verschillende bronnen voor je inspreken.",
        "icon": "bi-soundwave",
        "name": "Tekst-naar-Spraak-Omzetter"
      },
      "ai_chat": {
        "customBadgeLabel": "met assistenten",
        "description": "Gebruik de tekstgenererende AI voor ondersteuning bij veel taken.",
        "descriptionPupils": "Probeer uit bij welke taken de AI je kan helpen met leren.",
        "longDescriptionHtml": "Laat onze AI-assistentie je helpen bij het vormgeven van je lessen en het organiseren van je werk.",
        "name": "Chatten met AI",
        "useCasesHtml": "<ul> <li>Laat brieven aan ouders vertalen naar <strong>verschillende talen</strong>.</li> <li>Laat suggesties voor <strong>opdrachten en modelantwoorden</strong> aanmaken.</li> <li>Laat <strong>materiaallijsten</strong> voor experimenten aanmaken.</li> <li>Laat complexe teksten kort en <strong>leeftijdsadequaat samenvatten</strong>.</li> <li>Laat het <strong>programma van de ouderavond</strong> plannen.</li> <li>Laat de <strong>belangrijkste informatie</strong> over een onderwerp opzoeken.</li> <li>Laat <strong>codefragmenten</strong> genereren of herzien.</li> </ul>",
        "videos": [
          {
            "id": ""
          }
        ]
      },
      "ai_converter": {
        "description": "Maak podcasts, impulslezingen, audiosporen en transcripten uit verschillende bronnen",
        "longDescriptionHtml": "De AI-multimediatools bieden je nieuwe mogelijkheden om inhoud voor je lessen te creëren en om te zetten.",
        "name": "AI voor Mediacreatie",
        "useCasesHtml": "<ul><li>Zet inhoud om in een <strong>podcast of impulslezing</strong> over een onderwerp naar keuze - met audiospoor en transcript</li><li>Maak <strong>luistervaardigheidsoefeningen</strong> voor je lessen en laat audiosporen uit verschillende bronnen voor je inspreken.</li><li><strong>Zet spraakberichten en video's om in tekst</strong> en gebruik het transcript voor verdere opdrachten.</li><li>Ontvang een doorlopende tekst van foto's en tekst uit <strong>handschriften</strong>.</li></ul>",
        "videos": [
          {
            "id": ""
          }
        ]
      },
      "ai_dialog": {
        "description": "Laat dialogen als podcasts met twee sprekers inspreken.",
        "icon": "bi-chat-quote",
        "name": "Dialoogmaker"
      },
      "ai_document_qa": {
        "description": "Stel vragen over documenten en laat inhoud eenvoudig samenvatten met AI.",
        "descriptionPupils": "Stel vragen over de inhoud van PDF's en laat inhoud eenvoudig voor je verwerken.",
        "longDescriptionHtml": "Doorzoek specifieke documenten naar informatie en laat deze gericht voor je verwerken.",
        "name": "PDF-Chat",
        "useCasesHtml": "<ul> <li>Stel vragen over de volledige inhoud van een PDF.</li> <li>Laat de belangrijkste punten van een bron in elke gewenste lengte samenvatten.</li> <li>Doorzoek documenten naar inhoud en laat deze in de gewenste vorm verwerken.</li> <li>Ontvang een kant-en-klare structuur van de inhoud in een PDF.</li> <li>Laat kant-en-klare vraag-antwoordparen aanmaken voor toetsen en leervoortgangscontroles op basis van een specifieke bron.</td> </ul>",
        "videos": [
          {
            "id": ""
          }
        ]
      },
      "ai_feedback": {
        "description": "Ontvang AI-gegenereerde beoordelingssuggesties op basis van jouw criteria.",
        "longDescriptionHtml": "Bespaar waardevolle tijd bij het corrigeren door AI-ondersteunde foutcorrectie en beoordelingssuggesties.",
        "name": "Beoordelingsassistent",
        "useCasesHtml": "<ul> <li>Ontvang AI-gegenereerde foutenlijsten en voorcorrecties voor teksten van leerlingen.</li> <li>Stel eigen beoordelingscriteria vast en ontvang individuele feedback en verbetersuggesties.</li></ul>",
        "videos": [
          {
            "id": ""
          }
        ]
      },
      "ai_feedback_result": {
        "name": "Resultaten Beoordelingsassistent"
      },
      "ai_image": {
        "description": "Maak afbeeldingen op basis van tekstbeschrijvingen met behulp van beeldgenererende AI.",
        "descriptionPupils": "Experimenteer met beschrijvingen en stijlen en zet ze om in creatieve afbeeldingen.",
        "longDescriptionHtml": "Laat een gedachte omzetten in een <strong>afbeelding</strong> en illustreer concepten en ideeën in de les.",
        "name": "Afbeeldingsgenerator",
        "useCasesHtml": "<ul> <li>Maak rechtenvrije afbeeldingen ter <strong>illustratie van lesmateriaal</strong>.</li> <li>Ontvang <strong>meerdere versies van afbeeldingen</strong> en motieven in verschillende stijlen.</li> <li>Bespreek met leerlingen associaties, stijlen en <strong>creatieve mogelijkheden</strong>.</li> </ul>",
        "videos": [
          {
            "id": ""
          }
        ]
      },
      "ai_lecture": {
        "description": "Ontvang een korte lezing over een onderwerp naar keuze - met audiospoor en transcript.",
        "icon": "bi-book",
        "name": "Presentatiemaker"
      },
      "ai_message": {
        "name": "55+ Prompts"
      },
      "ai_mini_tool": {
        "customBadgeLabel": "55+ Tools",
        "description": "Gebruik kant-en-klare prompts om snel uiteenlopende taken voor je uit te voeren.",
        "icon": "bi-lightbulb",
        "longDescriptionHtml": "Meer dan 55 kant-en-klare promptvoorbeelden nemen terugkerende taken uit de schoolpraktijk van je over – van lesplanning tot oudercommunicatie, helemaal zonder zelf prompts te hoeven schrijven.",
        "name": "Promptlab",
        "useCasesHtml": "<ul> <li>Plan <strong>lessenreeksen en afzonderlijke lessen</strong> passend bij vak, leerjaar en onderwerp.</li> <li>Maak in seconden <strong>materialen en opdrachten</strong> met weinig gegevens.</li> <li>Vind <strong>differentiatie-ideeën</strong> om opdrachten aan te passen aan verschillende niveaus.</li> <li>Formuleer <strong>feedback en beoordelingen</strong> met passende formuleringhulpen.</li> <li>Bereid <strong>oudergesprekken en e-mails</strong> helder en in de juiste toon voor.</li> <li>Haal <strong>creatieve project- en lesideeën</strong> op voor nieuwe input.</li> </ul>",
        "videos": [
          {
            "id": ""
          }
        ]
      },
      "ai_mini_tool_request": {
        "name": "Promptlab-aanvragen"
      },
      "ai_my_assistants": {
        "description": "Maak je eigen chatbots met 'achtergrondkennis' en exacte instructies.",
        "icon": "bi-stars",
        "name": "Mijn Assistenten"
      },
      "ai_persona": {
        "description": "Voer gesprekken met chatbots van verschillende personages en figuren.",
        "descriptionPupils": "Chat met spannende en beroemde mensen of met grappige figuren.",
        "longDescriptionHtml": "Laat de AI in andere rollen kruipen, die je kunt ondervragen over hun kennis en ervaringen.",
        "name": "Personagechat",
        "useCasesHtml": "<ul> <li>Voer gesprekken met <strong>historische persoonlijkheden</strong> over de gebeurtenissen in het verleden.</li> <li><strong>Leer van experts</strong> op een bepaald gebied en vraag hen naar hun ervaringen.</li> <li>Voer een <strong>interview met schrijvers</strong> over de ontstaansgeschiedenis en achtergronden van hun werken.</li> <li>Test met <strong>grappige figuren</strong> de mogelijkheden en grenzen van Kunstmatige Intelligentie.</li> <li>Kies je favoriete persoon of figuur als leercoach en vraag hen naar <strong>tips voor jouw leerproces</strong> of een concrete opdracht.</li> </ul>"
      },
      "ai_podcast": {
        "description": "Zet inhoud om in een gesprek om naar te luisteren - met audiospoor en transcript.",
        "icon": "bi-mic",
        "name": "Podcastmaker"
      },
      "ai_summary": {
        "description": "Maak een samenvatting van een tekst, een website of andere bronnen.",
        "icon": "bi-journal-text",
        "name": "Samenvattingsgenerator"
      },
      "ai_text": {
        "description": "Zet teksten uit afbeeldingen of documenten om in doorlopende tekst.",
        "icon": "bi-file-earmark-font",
        "name": "Afbeelding-naar-Tekst-Omzetter"
      },
      "ai_transcript": {
        "description": "Zet de tekst van audiosporen of YouTube-video's om in transcripten.",
        "icon": "bi-vector-pen",
        "name": "Transcriptiegenerator"
      },
      "ai_translation": {
        "description": "Maak een vertaling van een tekst, een website of andere bronnen.",
        "icon": "bi-translate",
        "name": "Vertaler"
      },
      "audio_recorder": {
        "description": "Maak audio-opnamen en deel ze digitaal en veilig met leerlingen.",
        "icon": "bi-file-music",
        "longDescriptionHtml": "Maak audio-opnamen en deel deze vervolgens met een link of QR-code.",
        "name": "Audio-Opname",
        "useCasesHtml": "<ul> <li>Geef <strong>audio-feedback</strong> op huiswerk, projecten en toetsen</li> <li>Deel verborgen aanwijzingen via een audioboodschap bij een EduBreakout</li> <li>Stel extra <strong>auditieve ondersteuning</strong> beschikbaar, bijvoorbeeld voor leerlingen met leesproblemen</li> <li>Stuur groetberichten en spraakberichten naar leerlingen</li> </ul>",
        "videos": [
          {
            "id": ""
          }
        ]
      },
      "classroom_screen": {
        "description": "Maak multimediale schoolbordafbeeldingen, voeg inhoud toe en deel ze digitaal.",
        "longDescriptionHtml": "Maak multimediale schoolbordafbeeldingen en structureer je lesinhoud. Geef je les live en digitaal vorm.",
        "name": "Lesbord",
        "useCasesHtml": "<ul> <li>Visualiseer lesinhoud en verrijk deze <strong>met multimediale inhoud</strong></li> <li>Noteer en structureer inhoud en elementen op een <strong>dynamisch schoolbordbeeld</strong></li> <li><strong>Verzamel ideeën samen</strong> met je leerlingen</li> <li>Leg werkopdrachten overzichtelijk uit en deel ze op het digitale bord</li> <li>Een digitale klok, timer en symbolen voor werkfasen helpen je bij het <strong>structureren van je les</strong></li> </ul>",
        "videos": [
          {
            "id": ""
          }
        ]
      },
      "file_sharing": {
        "description": "Upload bestanden en deel ze digitaal en veilig met leerlingen.",
        "longDescriptionHtml": "Upload willekeurige bestanden en deel deze vervolgens met een link of QR-code.",
        "name": "Bestanden Delen",
        "useCasesHtml": "<ul> <li>Deel werkbladen en huiswerk <strong>eenvoudig en privacyveilig</strong> met leerlingen</li> <li>Verspreid <strong>lesmateriaal</strong> en <strong>werkopdrachten</strong> in tabletklassen</li> <li>Verleen tijdelijke toegangsrechten voor bepaalde leergroepen</li> <li>Wissel lesontwerpen en -materialen uit met collega's</li> </ul>",
        "videos": [
          {
            "id": ""
          }
        ]
      },
      "link_shortener": {
        "description": "Maak korte links voor digitale inhoud en deel ze digitaal en veilig met leerlingen.",
        "longDescriptionHtml": "Verkort een URL en deel deze vervolgens met een link of QR-code.",
        "name": "Linkverkorter",
        "useCasesHtml": "<ul> <li>Deel lesmateriaal, video's of digitale inhoud met <strong>veilige links</strong></li> <li>Verleen tijdelijke toegangsrechten voor geselecteerde leergroepen</li> <li>Beveilig je links <strong>met beschermde wachtwoorden</strong></li> </ul>",
        "videos": [
          {
            "id": ""
          }
        ]
      },
      "pinboard": {
        "defaults": {
          "boardName": "Eigen Prikbord",
          "cardName": "Kaart nr. 1",
          "listName": "Eerste lijst"
        },
        "description": "Maak interactieve prikborden en bewerk ze samen met leerlingen.",
        "longDescriptionHtml": "Werk samen met anderen aan een interactief bord. Gebruik kaarten om inhoud gestructureerd te delen.",
        "name": "Prikbord",
        "useCasesHtml": "<ul> <li>Maak <strong>digitale weekplanningen</strong> met werkopdrachten en lesmateriaal</li> <li>Maak tijdschema's voor digitale, hybride of fysieke bijeenkomsten</li> <li>Maak <strong>leerpleinen</strong> voor bepaalde lessenreeksen</li> <li>Verzamel voorkennis van leerlingen op een <strong>interactief bord</strong></li> <li>Documenteer lesinhoud en resultaten samen met leerlingen</li> </ul>",
        "videos": [
          {
            "id": ""
          }
        ]
      },
      "project": {
        "name": "Projecten in het klaslokaal"
      },
      "pupil_feedback": {
        "description": "Geef leerlingen toegang tot individuele AI-feedback op hun opdrachten.",
        "longDescriptionHtml": "Deze tool geeft leerlingen AI-gegenereerde terugkoppelingen en gedifferentieerde verbetersuggesties voor teksten en opdrachten.",
        "name": "Feedback voor Leerlingen",
        "useCasesHtml": "<ul> <li>Begeleid schrijftaken van je leerlingen met <strong>AI-gebaseerde feedback</strong> in realtime.</li> <li>Ondersteun leerlingen AI-gebaseerd in het zelfstandige leerproces en <strong>ervaar zelf merkbare verlichting.</strong></li> <li>Stuur de AI-gegenereerde feedback aan via <strong>individueel vastgestelde criteria</strong>.</li> </ul>",
        "videos": [
          {
            "id": ""
          }
        ]
      },
      "qrcodes": {
        "description": "Genereer QR-codes uit links en verwerk ze in lesmateriaal.",
        "longDescriptionHtml": "Maak een QR-code van een URL en deel deze vervolgens digitaal met je leerlingen.",
        "name": "QR-Codegenerator",
        "useCasesHtml": "<ul> <li>Deel lesmateriaal, presentaties of digitale bronnen direct via <strong>QR-codes</strong></li> <li><strong>Vergemakkelijk de toegang</strong> tot online enquêtes of feedbackformulieren voor je leerlingen</li> <li>Verwerk QR-codes in werkbladen of posters om <strong>aanvullende informatie</strong> te bieden</li> </ul>"
      },
      "school_class": {
        "description": "Deel werkopdrachten, materialen en AI-tools met je leerlingen – in een veilige, privacy-conforme leeromgeving.",
        "longDescriptionHtml": "Elke leerling werkt in een eigen omgeving aan jouw projecten, geheel zonder eigen fobizz-account. Jij bepaalt welke tools en materialen beschikbaar zijn en houdt alle activiteiten in de gaten.",
        "name": "Klassenruimte",
        "newFeaturesHtml": "<strong>Nieuw:</strong> Nodig andere docenten uit voor je projecten, filter activiteiten gericht, voeg eigen bestanden toe en koppel klassenruimtes aan je school.",
        "useCasesHtml": "<ul> <li>Kansen en risico's van AI samen testen en bespreken.</li> <li>De AI gebruiken als feedbackgever bij het schrijven en herzien van teksten.</li> <li>Eigen materialen en AI-assistenten beschikbaar stellen, bijv. een 'Taaltrainer' voor de vreemdetalenles.</li> <li>In gesprek gaan met historische sparringpartners en nieuwe perspectieven innemen.</li> </ul>",
        "useCasesTitle": "Zo kun je het inzetten:",
        "videoIntroText": "Onze video laat je in ongeveer 5 minuten zien hoe je stap voor stap een klassenruimte inricht.",
        "videos": [
          {
            "id": ""
          }
        ]
      },
      "screen_recorder": {
        "description": "Maak schermopnames en deel ze veilig.",
        "longDescriptionHtml": "Maak schermopnames en deel ze vervolgens via een link of QR-code.",
        "name": "Schermopname",
        "useCasesHtml": "<ul> <li>Maak <strong>uitlegvideo's</strong> en <strong>werkopdrachten via schermvideo</strong></li> <li>Presenteer in een <strong>schermopname</strong> het gebruik van <strong>websites</strong> of <strong>programma's</strong></li> <li>Geef <strong>videofeedback</strong> op digitaal ingeleverde huiswerk, projecten en toetsen</li> <li>Werk in een <strong>schermvideo</strong> een <strong>modelantwoord</strong> uit</li> </ul>",
        "videos": [
          {
            "id": ""
          }
        ]
      },
      "surveys": {
        "description": "Maak enquêtes, deel ze en de resultaten, en evalueer ze digitaal.",
        "icon": "bi-clipboard-data",
        "longDescriptionHtml": "Maak een enquête om in te vullen en kies daarbij uit verschillende vraag-/opdrachttypen. Deel de enquête via een link of QR-code en evalueer de resultaten.",
        "name": "Enquête",
        "useCasesHtml": "<ul> <li>Maak <strong>enquêtes, formulieren</strong> en <strong>kennistoetsen</strong></li> <li>Peil (voorkennis), meningen en zelfbeoordelingen van leerlingen</li> <li>Maak quizzen en leerniveaumetingen, oefeningen en opdrachten</li> <li>Verzamel <strong>lesfeedback</strong> digitaal en anoniem en evalueer het online</li> <li>Verzamel de resultaten digitaal en evalueer ze eenvoudig en overzichtelijk</li> </ul>",
        "videos": [
          {
            "id": ""
          }
        ]
      },
      "to_teach_worksheet_import": {
        "description": "Importeer je inhoud direct van to teach en gebruik deze o.a. in de fobizz klassenruimte.",
        "name": "Werkblad"
      },
      "text_editor": {
        "description": "Stel tekstdocumenten op en bewerk ze samen met leerlingen - met AI-hulp.",
        "descriptionPupils": "Stel tekstdocumenten op en bewerk ze samen.",
        "longDescriptionHtml": "Maak tekstdocumenten zonder technische voorkennis en deel ze vervolgens via een link of QR-code.",
        "name": "Tekstbewerker",
        "useCasesHtml": "<ul> <li>Groepsprojecten en brainstormen: Leerlingen kunnen samen aan projecten werken en ideeën of onderwerpen verzamelen die in de les besproken moeten worden.</li> <li>Samenvattingen en notulen: Leerlingen kunnen samen documenten opstellen, inhoud organiseren en structureren.</li> <li>Creatief schrijven en schrijfconferenties: Leerlingen kunnen eigen of andermans teksten samen met klasgenoten schrijven, herzien en verbeteren.</li> <li>AI: De geïntegreerde kunstmatige intelligentie helpt bij het schrijven en herzien van de inhoud en ondersteunt met spelling- en grammaticatips en met vertaalhulp.</li> </ul>",
        "videos": [
          {
            "id": ""
          }
        ]
      },
      "video_recorder": {
        "description": "Maak video-opnames en deel ze digitaal en veilig met leerlingen.",
        "longDescriptionHtml": "Maak video-opnames en deel ze vervolgens via een link of QR-code.",
        "name": "Video-Opname",
        "useCasesHtml": "<ul> <li>Maak eenvoudige <strong>uitlegvideo's</strong> en <strong>werkopdrachten via video</strong></li> <li>Geef <strong>videofeedback</strong> op huiswerk, projecten en toetsen</li> <li>Stel leerhulpen of opdrachten voor interne differentiatie beschikbaar via <strong>videobericht</strong></li> </ul>",
        "videos": [
          {
            "id": ""
          }
        ]
      },
      "website": {
        "description": "Maak eenvoudige digitale webpagina's, voeg inhoud toe en deel ze digitaal.",
        "icon": "bi-window",
        "longDescriptionHtml": "Maak een webpagina zonder technische voorkennis en deel deze vervolgens via een link of QR-code.",
        "name": "Website",
        "useCasesHtml": "<ul> <li>Gebruik de webpagina als <strong>digitaal wit vel papier</strong> dat je met vrije inhoud kunt vullen</li> <li>Maak <strong>spiekbriefjes, ouderbrieven of blogberichten</strong> en deel ze met ouders en leerlingen</li> <li>Deel een <strong>verzameling links</strong> over een bepaald onderwerp</li> <li>Maak <strong>leerpaden en leertafels</strong> met multimediale inhoud</li> </ul>",
        "videos": [
          {
            "id": ""
          }
        ]
      },
      "word_clouds": {
        "description": "Maak woordwolken met vragen en flitslichten en deel ze digitaal.",
        "longDescriptionHtml": "Maak woordwolken uit een lijst met woorden of samenwerkend met je leerlingen.",
        "name": "Woordwolk",
        "newlineSeparatedWordsPlaceholder": "Als\nvliegen\nachter\nvliegen\nvliegen\nvliegen\nvliegen\nachter\nvliegen\naan",
        "useCasesHtml": "<ul> <li>Maak woordwolken als activerende lesstart </li> <li>Gebruik woordwolken <strong>voor creatief brainstormen</strong> met leerlingen</li> <li>Peil voorkennis of associaties van leerlingen</li> <li>Verzamel <strong>stemmingsbeelden</strong> in de les of tijdens ouderavonden</li> </ul>",
        "videos": [
          {
            "id": ""
          }
        ]
      },
      "worksheet": {
        "consolidatedDescription": "Werkbladen zelf maken, via AI genereren of importeren van to teach.",
        "description": "Maak werkbladen met eigen inhoud, deel en evalueer ze digitaal.",
        "longDescriptionHtml": "Maak een werkblad om in te vullen en kies daarbij uit verschillende vraag-/opdrachttypen. Deel je werkblad via een link of QR-code en evalueer de resultaten online.",
        "name": "Werkblad",
        "useCasesHtml": "<ul> <li>Maak <strong>digitale werkbladen</strong>, formulieren, kennistoetsen, quizzen en leerniveaumetingen</li> <li>Integreer meerkeuzevragen, invulteksten, aanwijzingen en vrije werkopdrachten met een paar klikken</li> <li>Verzamel de <strong>resultaten digitaal</strong> en evalueer ze eenvoudig en overzichtelijk online</li> <li>Verzamel lesfeedback digitaal en anoniem en evalueer het online</li> <li>Peil (voorkennis), meningen en zelfbeoordelingen van leerlingen</li> <li>Print de sjablonen eventueel uit en <strong>gebruik ze analoog</strong></li> </ul>",
        "videos": [
          {
            "id": ""
          }
        ]
      },
      "worksheet_wizard": {
        "description": "Maak werkbladen met AI-gegenereerde opdrachten, deel en evalueer ze digitaal",
        "name": "AI-Werkbladassistent"
      }
    }
  }
}
